export default __webpack_public_path__ + "static/media/flight.afd34b64.jpg";